export default "__VITE_ASSET__GoNoWzGN__"